import { calmComputed } from "../../lib/utils";
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../lib/utils/consts";
export const propPanelMixin = {
  inject: {
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    },
    designer: {
      from: INJECT_UICORE_DESIGNER,
      default: null
    }
  },
  props: {
    compPath: String
  },
  computed: {
    comp: calmComputed(function () {
      return this.designer.getCompAtPath(this.compPath);
    }),
    compType: calmComputed(function () {
      var _this$comp;
      return (_this$comp = this.comp) === null || _this$comp === void 0 ? void 0 : _this$comp.type;
    }),
    compMeta() {
      return this.uc.components[this.compType];
    },
    defaultProps() {
      var _this$compMeta;
      return (_this$compMeta = this.compMeta) === null || _this$compMeta === void 0 ? void 0 : _this$compMeta.defaultProps;
    },
    isLogicComponent() {
      return /\/@triggers\/\d+$/.test(this.compPath);
    }
  },
  methods: {
    /**
     * 修改当前组件的某个prop
     *
     * @public
     */
    updateCompProp(key, value) {
      return this.designer.updateCompProp(this.compPath, key, value);
    },
    /**
     * 获取当前选中的组件的实例
     *
     * @public
     */
    getCompInstance() {
      return this.designer.renderer.getRefByPath(this.compPath);
    },
    /**
     * 获取当前组件实际的 prop 值。如果组件未初始化，会获取到 undefined
     *
     * @param {string} propName
     */
    getActualProp(propName) {
      var _this$getCompInstance;
      return (_this$getCompInstance = this.getCompInstance()) === null || _this$getCompInstance === void 0 ? void 0 : _this$getCompInstance.$props[propName];
    },
    /**
     * 删除当前选中的组件
     *
     * @public
     */
    deleteComp() {
      return this.designer.deleteComp(this.compPath);
    },
    /**
     * 更新当前选中的组件。
     *
     * 参数可以是一个函数（直接在传入的 Comp数据上修改）
     *
     * @param {(comp: UICore.Comp, root: UICore.Comp) => void} modifyFn
     */
    modifyComp(modifyFn) {
      return this.designer.modifyComp(this.compPath, modifyFn);
    },
    /**
     * 替换当前组件为其他的东西
     *
     * @param {UICore.Layout[]} newItems
     */
    replaceCompWith(...newItems) {
      return this.designer.replaceCompWith(this.compPath, ...newItems);
    },
    /**
     * 通知 UICore 页面发生了编辑行为，可带上参数过多久提交这个修改。可以给个 `0` 表示立即保存修改，不然会等待 500ms 才会生效
     */
    notifyPageletsChange(delay) {
      return this.uc.notifyPageletsChange(delay);
    }
  }
};
//# sourceMappingURL=propPanelMixin.js.map
